import { Box } from '@chakra-ui/react';
import styled from 'styled-components';

export const Container = styled(Box)``;
